export const calendarTheme = {
    selectedOpacity: 0.96,
    backgroundPlanetOpacity: 0.2,
    backgroundPlanetLimit: 7,
    harmonyFillOpacity: 0.2,
    tensionFillOpacity: 0.18,
    keyMarkerThreshold: 0.68,
    strongEventThreshold: 0.72,
    smoothingWindow: 1,
    weekGraph: {
        width: 700,
        height: 82,
        centerY: 42,
        amplitude: 28,
    },
    colors: {
        harmony: "#7dd8d1",
        tension: "#e46f83",
        key: "#f5c66b",
        grid: "rgba(246, 241, 231, 0.12)",
        ink: "#f6f1e7",
        muted: "#9da8b7",
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FsZW5kYXJUaGVtZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NvdXJjZXMvbWluaWFwcC9jb25maWcvY2FsZW5kYXJUaGVtZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUc7SUFDM0IsZUFBZSxFQUFFLElBQUk7SUFDckIsdUJBQXVCLEVBQUUsR0FBRztJQUM1QixxQkFBcUIsRUFBRSxDQUFDO0lBQ3hCLGtCQUFrQixFQUFFLEdBQUc7SUFDdkIsa0JBQWtCLEVBQUUsSUFBSTtJQUN4QixrQkFBa0IsRUFBRSxJQUFJO0lBQ3hCLG9CQUFvQixFQUFFLElBQUk7SUFDMUIsZUFBZSxFQUFFLENBQUM7SUFDbEIsU0FBUyxFQUFFO1FBQ1QsS0FBSyxFQUFFLEdBQUc7UUFDVixNQUFNLEVBQUUsRUFBRTtRQUNWLE9BQU8sRUFBRSxFQUFFO1FBQ1gsU0FBUyxFQUFFLEVBQUU7S0FDZDtJQUNELE1BQU0sRUFBRTtRQUNOLE9BQU8sRUFBRSxTQUFTO1FBQ2xCLE9BQU8sRUFBRSxTQUFTO1FBQ2xCLEdBQUcsRUFBRSxTQUFTO1FBQ2QsSUFBSSxFQUFFLDJCQUEyQjtRQUNqQyxHQUFHLEVBQUUsU0FBUztRQUNkLEtBQUssRUFBRSxTQUFTO0tBQ2pCO0NBQ0YsQ0FBQyJ9